import { useInView } from 'react-hook-inview'
import { useState, useEffect, useRef, useMemo, useCallback, } from 'react';
import { ShieldBan, CloudAlert, SearchX } from 'lucide-react';
import {
  useInfiniteQuery,
  useMutation
} from '@tanstack/react-query'
import { mockTelegramEnv, retrieveLaunchParams, postEvent, init, miniApp, backButton } from '@telegram-apps/sdk';
import { initDataDefault, useStartParam, usePlatform } from "./utils/telegram"
import cn from 'classnames'
import { useAtom, useSetAtom, useAtomValue } from 'jotai'
import BottomBar from './components/BottomBar';
import { useAuthHeader, useApi } from "./utils/api"
import {eventTragetControl, interractedAtom, selectedLangAtom, isMutedAtom, activeTabAtom, queryClient, isLoadedDirectDoneAtom, personalRefCodeAtom, watchingPageAtom } from "./utils/states"
import VideoJS from './components/Player';
import telegramAnalytics from '@telegram-apps/analytics';
import { useTranslation, se } from "react-i18next";
import { motion, AnimatePresence } from "motion/react"


function Player2({ uri, playerRef, setLoaded, isAd }) {
  const muted = useAtomValue(isMutedAtom);
  const videoJsOptions = useMemo(_ => ({
    controls: false,
    autoplay: false,
    fluid: false,
    loop: true,
    muted: muted,
    fill: true,
    responsive: false,
    width: document.body.scrollWidth,
    enableSmoothSeeking: true,
    preload: 'metadata',
    sources: [{
      src: uri,
      type: 'application/x-mpegURL'
    }]
  }), [uri]);
  const memoizedHandlePlayerReady = useCallback((player) => {
    console.log("player ref updated");
    playerRef.current = player;
    player.on('waiting', () => {
      setLoaded(false);
    });
    player.on('canplaythrough', () => {
      setLoaded(true);
    });
    player.on('loadeddata', () => {
      setLoaded(true);
    });
    player.on('loadedmetadata', () => {
      setLoaded(true);
    })
  }, []);

  useEffect(_ => {  
    if (playerRef.current) {
      if (muted) {
        playerRef.current.muted(true);
      } else {
        playerRef.current.muted(false);
      }
    }
  }, [muted]);

  return <VideoJS options={videoJsOptions} onReady={memoizedHandlePlayerReady} isAd={false} />;
}

function Timeline({ playerRef, videoKey }) {
  const {endVideoWatch} = useApi();
  const timerCurrentRef = useRef(null);
  const timerTotalRef = useRef(null);
  const timeLineRef = useRef(null);


  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.on("timeupdate", _ => {
        const curTime = playerRef.current.currentTime();
        const duration = playerRef.current.duration();
        const percent = Math.min((curTime + 0.5) / duration, 1);
        const computed = (90 * Math.atan(3/(percent * document.body.clientWidth)) / Math.PI); 

        if (timerCurrentRef.current) {
          const curTimeSeconds = String(Math.floor(curTime - 60*Math.floor(curTime/60))).padStart(2, '0');
          timerCurrentRef.current.textContent = `${Math.floor(curTime/60)}:${curTimeSeconds}`;
        }

        if (timerTotalRef.current) {
          const durationSeconds = String(Math.floor(duration - 60*Math.floor(duration/60))).padStart(2, '0');
          timerTotalRef.current.textContent =`${Math.floor(duration/60)}:${durationSeconds}`;
        }

        if (timeLineRef.current) {

          const prevWidth = +timeLineRef.current.style.width.split('%')[0];
          const newWidth = percent * 100;

          if (prevWidth > newWidth) {
            endVideoWatch(videoKey, duration).finally(_ => {});
            timeLineRef.current.style.transitionDuration = '0ms';
            timeLineRef.current.style.width = `0%`;
          } else {
            timeLineRef.current.style.transitionDuration = '500ms';
            timeLineRef.current.style.width = `${newWidth}%`;
          }

          const el1 = timeLineRef.current.children[0];
          const el2 = timeLineRef.current.children[1];

          el1.style.transform = `rotate(${computed}deg) translateZ(-1px)`;
          el2.style.transform = `rotate(-${computed}deg) translateZ(-1px)`;

        }

      });
    }
  }, [playerRef.current]);
  
  return (
    <div className="absolute z-[13] bottom-0 left-0 w-full px-4 box-border flex flex-col disable-select bg-grad-f2">
      <div className="flex flex-row justify-between">
        <span className='text-xs text-white/70 font-bold' ref={timerCurrentRef}></span>
        <span className='text-xs text-white/40 font-bold' ref={timerTotalRef}></span>
      </div>
      <div className="relative w-full h-[8px] flex flex-row justify-start rounded-full">
        <div className={"flex flex-col justify-center h-[8px] rounded-full ease-linear transition-width duration-500 overflow-x-hidden"} ref={timeLineRef}>
          <div className={`origin-left h-[4px] w-full bg-white rounded-b-full  ease-linear transition-all duration-500 rounded-l-full sm-line`} />
          <div className={`origin-left h-[4px] mt-[-4px] w-full bg-white ease-linear transition-all duration-500 rounded-t-fullrounded-l-full sm-line`} />
        </div>
        <div className='absolute top-[2px] w-full h-[4px] bg-white/10 rounded-full' />
      </div>
    </div>
  )
}

function SvgSpinnersRingResize(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" {...props}><g stroke="currentColor"><circle cx="12" cy="12" r="9.5" fill="none" strokeLinecap="round" strokeWidth="3"><animate attributeName="stroke-dasharray" calcMode="spline" dur="1.5s" keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" keyTimes="0;0.475;0.95;1" repeatCount="indefinite" values="0 150;42 150;42 150;42 150"></animate><animate attributeName="stroke-dashoffset" calcMode="spline" dur="1.5s" keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" keyTimes="0;0.475;0.95;1" repeatCount="indefinite" values="0;-16;-59;-59"></animate></circle><animateTransform attributeName="transform" dur="2s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"></animateTransform></g></svg>
  )
}

function SolarVolumeSmallBoldDuotone(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M3.003 11.716c.04-1.843.059-2.764.697-3.552c.117-.144.288-.315.432-.431c.785-.636 1.822-.636 3.897-.636c.741 0 1.112 0 1.465-.092q.11-.03.218-.067c.345-.121.654-.33 1.273-.746c2.442-1.645 3.662-2.467 4.687-2.11c.196.069.387.168.556.29c.886.635.953 2.115 1.088 5.073c.05 1.096.084 2.034.084 2.555s-.034 1.46-.084 2.555c-.134 2.958-.202 4.438-1.088 5.073c-.17.122-.36.221-.556.29c-1.025.357-2.245-.465-4.687-2.11c-.619-.416-.928-.625-1.273-.746a3 3 0 0 0-.218-.067c-.353-.092-.724-.092-1.465-.092c-2.075 0-3.112 0-3.897-.636a3 3 0 0 1-.432-.43c-.638-.79-.658-1.71-.697-3.552a13 13 0 0 1 0-.57"></path><path fill="currentColor" fillRule="evenodd" d="M19.45 8.416a.71.71 0 0 1 .98.286l-.63.357l.63-.357l.001.002l.002.003l.003.007l.01.018a2 2 0 0 1 .098.224c.056.144.126.349.194.619c.135.54.262 1.337.262 2.425c0 1.089-.127 1.886-.262 2.426c-.068.27-.138.475-.194.619a3 3 0 0 1-.098.223l-.01.018l-.003.007l-.002.003v.002s-.001.001-.63-.356l.629.357a.71.71 0 0 1-.98.286a.744.744 0 0 1-.284-.991l.005-.01l.036-.085a4 4 0 0 0 .136-.438c.104-.416.217-1.09.217-2.06c0-.971-.113-1.645-.217-2.061a4 4 0 0 0-.172-.523l-.005-.01a.744.744 0 0 1 .285-.991" clipRule="evenodd" opacity=".5"></path></svg>
  )
}

function SolarMutedBoldDuotone(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M17 16c-1.886 0-2.828 0-3.414-.586S13 13.886 13 12s0-2.828.586-3.414S15.114 8 17 8s2.828 0 3.414.586S21 10.114 21 12s0 2.828-.586 3.414S18.886 16 17 16m-1.306-6.25a.667.667 0 0 0-.943.944L16.057 12l-1.306 1.306a.667.667 0 0 0 .943.943L17 12.943l1.306 1.306a.667.667 0 0 0 .943-.943L17.943 12l1.306-1.306a.667.667 0 0 0-.943-.943L17 11.057z" clipRule="evenodd"></path><path fill="currentColor" d="M3.003 11.716c.038-1.843.057-2.764.678-3.552c.113-.144.28-.315.42-.431c.763-.636 1.771-.636 3.788-.636c.72 0 1.081 0 1.425-.092a3 3 0 0 0 .211-.067c.336-.121.637-.33 1.238-.746c2.374-1.645 3.56-2.467 4.557-2.11c.191.069.376.168.541.29c.708.522.878 1.614.989 3.628c-1.786 0-2.694.016-3.264.586C13 9.172 13 10.114 13 12s0 2.828.586 3.414c.57.57 1.478.586 3.264.586c-.111 2.014-.281 3.106-.989 3.628a2.2 2.2 0 0 1-.54.29c-.997.357-2.184-.465-4.558-2.11c-.601-.416-.902-.625-1.238-.746a3 3 0 0 0-.211-.067c-.344-.092-.704-.092-1.425-.092c-2.017 0-3.025 0-3.789-.636a3 3 0 0 1-.419-.43c-.621-.79-.64-1.71-.678-3.552a14 14 0 0 1 0-.57" opacity=".5"></path></svg>
  )
}




function TextBlock({ text }) {
  const [expanded, setExpanded] = useState(false);
  const expand = e => {
    e.stopPropagation();  
    if (text !== '') setExpanded(s => !s);
  }
  const textParts = text.split('\n');
  return (
    <>
        <div className={cn(
            expanded ? 'pb-4' : '',
            'disable-select cursor-pointer relative flex flex-col w-full pt-1 bottom-0', 
            'grad-bg w-full mb-[24px] z-[12] overflow-hidden  pl-4 pr-[5em]'
          )}>
          <div onMouseDown={expand} onTouchStart={expand} className={cn(
            expanded ? 'h-auto max-h-[80%]' : 'h-[2em] grad-overlay',
            'disable-select cursor-pointer relative flex flex-col w-full', 
            'text-white text-sm box-border text-lefttext-ellipsis'
          )}>{textParts.map((v, i) => <p key={i} className='pb-1 font-medium'>{v}</p>)}</div>
        </div>
    </>
  )
}

export function SolarArrowRightUpBoldDuotone(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M17.47 15.53a.75.75 0 0 0 1.28-.53V6a.75.75 0 0 0-.75-.75H9a.75.75 0 0 0-.53 1.28z" clipRule="evenodd"></path><path fill="currentColor" d="M5.47 17.47a.75.75 0 1 0 1.06 1.06l6.97-6.97l-1.06-1.06z" opacity=".5"></path></svg>
  )
}


function TapControl({ children, isVisible }) {

  const setMuted = useSetAtom(isMutedAtom);

  useEffect(_ => {
    if (isVisible) {
      eventTragetControl.addEventListener("mute", muteHandle);
    } else {
      eventTragetControl.removeEventListener("mute", muteHandle);
    }
    return _ => {
      eventTragetControl.removeEventListener("mute", muteHandle);
    }
  }, [eventTragetControl, isVisible]);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    eventTragetControl.pressStart(e.changedTouches ? e.changedTouches[e.changedTouches.length - 1].clientX : e.screenX);
  }, [eventTragetControl]);

  const cancelMouseMove = useCallback((e) => {
    e.preventDefault();
    eventTragetControl.cancel(e.changedTouches ? e.changedTouches[e.changedTouches.length - 1].clientX : e.screenX);
  }, [eventTragetControl]);

  const handleMouseUp = useCallback((e) => {
    e.preventDefault();
    eventTragetControl.pressEnd();
  }, [eventTragetControl]);

  const muteHandle = useCallback(() => {
    setMuted(s => !s);
  }, []);

  return <div
    onMouseDown={handleMouseDown}
    onTouchStart={handleMouseDown}
    onTouchMove={cancelMouseMove}
    onMouseMove={cancelMouseMove}
    onTouchEnd={handleMouseUp}
    onMouseUp={handleMouseUp}
    className="w-full h-full absolute flex flex-col z-10 justify-end"
    >{children}
  </div>;
}

function MutedOverlay() {
  const muted = useAtomValue(isMutedAtom)
  const [opacity, setOpacity] = useState(1);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(_ => {
    setOpacity(1);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    setTimeoutId(setTimeout(_ => setOpacity(0), 950));
    return _ => {
      clearTimeout(timeoutId);
    }
  }, [muted]);
  return <div style={{opacity: opacity}} className={cn('transition-all absolute z-[0] w-full h-full flex justify-center items-center ')}>
    <div className="flex w-[5em] h-[5em] bg-black/40 text-white/80 justify-center items-center rounded-xl">
      {muted ? (<SolarMutedBoldDuotone size={48} />) : (<SolarVolumeSmallBoldDuotone size={48} />)}
    </div>
  </div>
}

function Item(props) {
  const { index, viewport } = props;
  const parentRef = useRef(null);
  const [visibleDirection, setVisible] = useState("");
  const [conextRef, isVisible] = useInView({
    threshold: 0.1
  });

  const setRef = useCallback((el) => {
    parentRef.current = el;
    conextRef(el);
  }, []);

  useEffect(_ => {
    if (visibleDirection !== "") {
      props.setVisi(false);
    }
  }, [visibleDirection]);

  return (
      <motion.div
        id={`video-${index}`}
        ref={setRef}
        initial={{opacity: 0 }}
        whileInView={{opacity: 1 }}
        viewport={viewport}
        exit={{ position: 'absolute', display: 'none', opacity: 0,  transform: visibleDirection === "skip" ? `rotate(-20deg) scale(0.75) translateX(-200%)` : `rotate(20deg) scale(0.75) translateX(200%)` }}
        transition={{ duration: .5, ease: "linear" }}
        className={cn(
          "sm-line overflow-hidden disable-select w-full h-[calc(100%+1px)]",
          "top-0 relative snap-center flex flex-row bg-black",
          "justify-center items-center transition-all duration-0"
        )}>
        <ItemContent {...props} isVisible={isVisible} parentRef={parentRef} setVisible={setVisible} />
      </motion.div>
  )
}

function OverlayEmoji(props) {
  const { playerRef, words } = props;
  const [wordSelected, setWordSelected] = useState(null);

  const wordMap = {
    "hi.webp": ["hello", "привет"],
    "money.webp": ["dollar", "ruble", "деньги", "доллар", "рублей"],
    "food.webp": ["tasty", "вкусно", "вкусный"],
    "power.webp": ["power", "мощный"],
  }

  useEffect(() => {
    if (playerRef.current && words.length > 0) {
      var wordSelected2 = null;
      setInterval(_ => {
        const curTime = 1000 * playerRef.current.currentTime();
        var wordText = "";
        for (let word of words) {
          if (curTime > word.range[0] && curTime < (word.range[0] + 2000)) {
            wordText = word.word.toLowerCase();
          }
        }
        let wordText2 = "";
        for (let key in wordMap) {
          if (wordText2 !== "") break;
          for (let word of wordMap[key]) {
            if (wordText.includes(word)) {
              wordText2 = key;
              break;
            }
          }
        }
        if (wordText2.length === 0) {
          return
        }
        if (wordSelected2 !== wordText2) {
          wordSelected2 = wordText2;
          setWordSelected(wordText2);
          setTimeout(_ => setWordSelected(null), 2000);
        }
      }, 70);
    }
  }, [playerRef.current, words]);

  return (
    <div className='absolute w-[40px] bottom-14 z-30 right-4'>
      {wordSelected ? <div className='animate-[appear_2.5s_1_linear]'>
          <img className='animate-[sin_0.8s_alternate_infinite_ease-in-out]' src={wordSelected} />
      </div> : null }
    </div>
  )
}


function ItemContent(props) {

  const {isVisible, parentRef, setVisible } = props;
  const playerRef = useRef(null);
  const platform = usePlatform();
  const [loaded, setLoaded] = useState(false);
  const [words, setWords] = useState([]);
  const setPage = useSetAtom(watchingPageAtom);
  const {initiateVideoWatch, endVideoWatch, likeVideo, getVideoMetadata} = useApi();

  const handleEventX = useCallback((e) => {
    if (parentRef && isVisible) {
      const deltaX = e.detail.delta_x;
      parentRef.current.style.borderRadius = '25px';
      parentRef.current.style.transform = `translateX(${-deltaX}px) scale(${0.95 - 0.5*Math.abs(deltaX)/document.body.clientWidth}) rotate(${-20*deltaX/document.body.clientWidth}deg)`
      parentRef.current.style.opacity = `${1 - 0.8*Math.abs(deltaX)/document.body.clientWidth}`
    }
  }, [parentRef, isVisible]);

  const skipHandle = useCallback(_ => {
    if (parentRef && isVisible) {
      if (parentRef.current.style.transform === '') {
        parentRef.current.style.transform = `rotate(0deg) scale(1.0) translateX(0%)`;
      }
      setVisible("skip");
      postEvent('web_app_trigger_haptic_feedback', { type: 'notification', notification_type: 'error' });
      endVideoWatch(props.video.file.key, playerRef.current.currentTime()).finally(_ => {});
      likeVideo(props.video.file.key, -1);
    }
  }, [parentRef, isVisible]);

  const likeHandle = useCallback(_ => {
    if (parentRef && isVisible) {
      if (parentRef.current.style.transform === '') {
        parentRef.current.style.transform = `rotate(0deg) scale(1.0) translateX(0%)`;
      }
      setVisible("like");
      postEvent('web_app_trigger_haptic_feedback', { type: 'notification', notification_type: 'success' });
      endVideoWatch(props.video.file.key, playerRef.current.currentTime()).finally(_ => {});
      likeVideo(props.video.file.key, 1);
    }
  }, [parentRef, isVisible]);

  const handleStopIterraction = useCallback(_ => {
    if (parentRef && isVisible) {
      parentRef.current.style.transform = `scale(1.0)`;
      parentRef.current.style.opacity = `1`;
      parentRef.current.style.borderRadius = '0px';
    }
  }, [parentRef, isVisible]);

  const playHandle = useCallback(_ => {
    if (playerRef.current) {
      playerRef.current.play().catch(e => {});
    }
  }, []);

  const pauseHandle = useCallback(_ => {
    if (playerRef.current) {
      playerRef.current.pause();
    }
  }, []);

  
  useEffect(_ => {
    const mapEvents = {
      changeX: handleEventX,
      skip: skipHandle,
      like: likeHandle,
      stopInterraction: handleStopIterraction,
      play: playHandle,
      pause: pauseHandle,
    };
    if (isVisible) {
      for (let key in mapEvents) {
        eventTragetControl.addEventListener(key, mapEvents[key]);
      }
    } else {
      for (let key in mapEvents) {
        eventTragetControl.removeEventListener(key, mapEvents[key]);
      }
    }
    return _ => {
      for (let key in mapEvents) {
        eventTragetControl.removeEventListener(key, mapEvents[key]);
      }
    }
  }, [isVisible]);

  useEffect(() => {
    if (playerRef.current && !isVisible) {
      playerRef.current.pause();
      playerRef.current.currentTime(0); 
    } else if (playerRef.current) {
      playerRef.current.play().catch(e => {});
    }
  }, [loaded, playerRef, isVisible]);

  useEffect(() => {
    if (isVisible) {
      setPage(props.index);
      initiateVideoWatch(props.video.file.key).then(_ => {});
    }
    if (isVisible && props.watch) {
      props.update();
    }
  }, [isVisible, props.watch]);

  const shareTap = (e) => {
    e.stopPropagation();
    if (platform === 'tdesktop') {
      window.open(props.video.author.msg, '_blank').focus();
    } else {
      postEvent('web_app_open_tg_link', { path_full: props.video.author.path })
    }
  };

  useEffect(_ => {
    getVideoMetadata(props.video.file.key).then(resp => {
      if (resp && resp.data && resp.data.words) {
        setWords(resp.data.words);
      }
    })
  }, []);

  return (
    <>
      <Player2 isAd={props.index > 4} uri={props.video.file.uri} setLoaded={setLoaded} playerRef={playerRef} />
      {loaded ? null : (<div className='z-1 flex absolute top-0 h-full text-white justify-center items-center text-center w-full flex-col gap-4 text-lg'>
        <SvgSpinnersRingResize />
      </div>)}
      <MutedOverlay />
      <TapControl isVisible={isVisible}>
        <OverlayEmoji playerRef={playerRef} words={words} />
        <div className="disable-select w-full relative flex flex-row grad-bg-2"> 
            <div className="flex flex-col flex-grow text-white justify-end align-bottom pl-4 pt-4 items-start gap-1">
              <span className='text-left text-xs font-bold text-white/90 rounded-full bg-white/15 px-[10px] py-[3px]'>@{props.video.author.username}</span>
              <h2 className='text-lg text-left font-semibold cursor-pointer flex flex-row gap-1 items-center' onTouchStart={shareTap} onMouseDown={shareTap}>
                {props.video.author.title}
              <SolarArrowRightUpBoldDuotone className="mt-[2px]" />
              </h2>
            </div>
        </div>
        <TextBlock text={props.video.text} />
      </TapControl>
      <Timeline playerRef={playerRef} videoKey={props.video.file.key} />
    </>
  )
}

function LoadingItem(props) {
  const [ref, isVisible] = useInView({
    threshold: 0.1
  });

  useEffect(() => {
    if (isVisible && props.watch) {
      props.update();
    }
  }, [isVisible, props.watch]);

  return (
    <div id={"video-"+ props.index} className="relative w-full h-full snap-center flex flex-row bg-black" ref={ref}>
      <div className="w-full h-full absolute flex flex-row z-10">
        {props.error ? (
          <div className='flex absolute top-0 h-full text-white justify-center items-center text-center w-full flex-col gap-4 text-lg'>
            <>{(props.error === "access") ? <>
              <ShieldBan size={32} />
              Access error
            </> : (props.error === "server") ? <>
              <CloudAlert size={32} />
              Unknown error
            </> : <>
              <SearchX size={32} />
              No video found.
            </>}</>
          </div>
        ): (
          <div className='flex absolute top-0 h-full text-white justify-center items-center text-center w-full flex-col gap-4 text-lg'>
             <SvgSpinnersRingResize />
          </div>
        )}
        <div className="flex flex-col flex-grow text-white justify-end align-bottom p-4 pb-10 gap-5">
          <h2 className='text-left font-bold animate-pulse rounded-full w-[150px] h-[10px] bg-white/20'></h2>
          <span className='text-left animate-pulse rounded-full w-[100px] h-[10px] bg-white/20'></span>
        </div>
      </div>
    </div>
  )
}

// function useStartParam() {
//   const launchParams = retrieveLaunchParams();
//   if (launchParams && launchParams.initData) {
//       var param = launchParams.initData.startParam;
//       if (!param) {
//         return null;
//       }
//       param = (param !== "v_newsmoscow_18282") ? param : "v_sokolay_2789";
//       let splitParam = param.split("_");
//       if (splitParam.length < 1) {
//         return null;
//       }
//       if (splitParam.length >= 3 && splitParam[0] == "v") {
//         return {
//           type: "direct_video_message",
//           username: splitParam.slice(1, splitParam.length - 1).join('_'),
//           message: splitParam[splitParam.length-1],
//           referal: null,
//         }
//       }
//       if (splitParam.length >= 3 && splitParam[0] == "rv") {
//         return {
//           type: "direct_video_message",
//           username: splitParam.slice(1, splitParam.length - 2).join('_'),
//           message: splitParam[splitParam.length-2],
//           referal: splitParam[splitParam.length-1],
//         }
//       }
//   }     
//   return null;
// }

function WelcomeOverlay(props) {
  const { t } = useTranslation();
  return (
    <div {...props} className='absolute w-full h-full bg-black/60 z-30 top-0 text-white/80 flex justify-center items-center gap-2 flex-col px-12'>
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="m21.15 2.85l-1.02 1.02C18.69 2.17 15.6 1 12 1S5.31 2.17 3.87 3.87L2.85 2.85a.5.5 0 0 0-.85.36V6.5c0 .28.22.5.5.5h3.29c.45 0 .67-.54.35-.85L4.93 4.93c1-1.29 3.7-2.43 7.07-2.43s6.07 1.14 7.07 2.43l-1.22 1.22a.5.5 0 0 0 .36.85h3.29c.28 0 .5-.22.5-.5V3.21a.5.5 0 0 0-.85-.36"/><path fill="currentColor" d="M14.5 12.71c-.28-.14-.58-.21-.89-.21H13v-6c0-.83-.67-1.5-1.5-1.5S10 5.67 10 6.5v10.74l-3.44-.72a1.12 1.12 0 0 0-1.02 1.89l4.01 4.01c.37.37.88.58 1.41.58h6.41c1 0 1.84-.73 1.98-1.72l.63-4.46c.12-.85-.32-1.69-1.09-2.07z"/></svg>
      <span className="font-bold">{t("swipe demo 2")}</span>
    </div>
  )
}

function ScrollContainer({ showOverlayInitial, viewport }) {
    const startParam = useStartParam();
    const [sessionInit, setSessionInit] = useState(false);
    const [globalIndex, setIndex] = useState(0);

    const [showOverlay, setShowOverlay] = useState(showOverlayInitial);
    const {getDirectItemV2, getFeedItemsV2} = useApi();
    const [isLoadedDirect, setLoadedDirect] = useAtom(isLoadedDirectDoneAtom);
    
    const fetchNextVideo = async ({ pageParam }) => {
      if (!isLoadedDirect && pageParam === 0 && startParam && startParam.type === "direct_video_message") {
        return await getDirectItemV2(startParam)
      }
      setLoadedDirect(true);
      return await getFeedItemsV2()
    }
  
    const { data, fetchNextPage, isFetchingNextPage, error } = useInfiniteQuery({
      queryKey: ['videos'],
      queryFn: fetchNextVideo,
      initialPageParam: 0,
      refetchOnWindowFocus: false,
      initialData: { pages: [], pageParams: [] },
      enabled: sessionInit,
      getNextPageParam: (lastPage, allPages, lastPageParam) => {
        return lastPageParam + 1
      },
    })

    const hideOverlay = _ => {
      setShowOverlay(false);
    };

    const mutation = useMutation({
      mutationFn: () => {
        return fetchNextPage()
      },
      onMutate: async _ => {
        await queryClient.cancelQueries({ queryKey: ['videos'] })
        queryClient.setQueryData(['videos'], (old) => {
          var nextKeyMutation = 0
          if (old.pageParams.length > 0) {
            nextKeyMutation = old.pageParams.slice(-1)[0] + 1
          }
          return {
            pages: [...old.pages, {
              videos: [null],
              length: 1,
            }],
            pageParams: [...old.pageParams, nextKeyMutation],
          }
        })
        return {}
      },
      onSuccess: (result, variables, context) => {
        queryClient.setQueryData(['videos'], (old) =>{
          const filterPages = result.data.pages.filter((v) => v.length > 0 && v.videos[0] !== null);
            return {
            pages: filterPages,
            pageParams: filterPages.map((_, i) => i),
          }
        })
        queryClient.invalidateQueries({ queryKey: ['balance'] })
      },
    })

    const maybeMutate = () => {
        if (data.pages.length > 0 || (data.pages.length == 0 && startParam && startParam.type === "direct_video_message" && error && error.type && error.type === "not found")) {
          mutation.mutate({})
        } 
    }

    useEffect(() => {
      setSessionInit(true);
    }, [])

    if (error && error.type && !(data && data.pages && data.pages.length > 0)) {
      return <LoadingItem error={error.type} />;
    }

    if (!data || !data.pages || data.pages.length === 0) {
      return <LoadingItem watch={!isFetchingNextPage} update={maybeMutate} />;
    }


    var reducedVideos = data.pages.reduce(
      (accumulator, currentValue) => [...accumulator, ...currentValue.videos],
      []
    );

    reducedVideos = reducedVideos.filter((_, i) => i >= globalIndex);
    
    return (
      <>
        <AnimatePresence mode="sync">
          {reducedVideos.map((el, index) => (
            (el !== null) ? <Item viewport={viewport} setVisi={_ => setIndex(globalIndex + index + 1)} index={index + globalIndex} key={globalIndex +index + el} fetch={globalIndex + index < reducedVideos.length - 1} video={el} update={maybeMutate} watch={!isFetchingNextPage && ((reducedVideos.length === 1) ? (index + globalIndex == reducedVideos.length - 1) : (index + globalIndex >= reducedVideos.length - 2))} /> : null
          ))}
        </AnimatePresence>
        {showOverlay ? <WelcomeOverlay onClick={hideOverlay} /> : null}
      </>
    )
}

function ScrollVisibility({ showOverlayInitial }) {
  const ref = useRef(null);
  return (
    <div ref={ref} className="relative w-full h-full overflow-hidden no-scrollbar touch-none">
        <ScrollContainer showOverlayInitial={showOverlayInitial} viewport={ref} />
    </div>
  );
}

// function AppGlobalLoader() {
//   return (
//     <div className='h-[100vh] w-[100vw] text-white flex flex-col justify-center items-center text-center' />
//   )
// }


function RegularButton({ text1, text2, onClick }) {
  return (
    <button onClick={onClick} className="flex flex-row w-full justify-between rounded-xl bg-[#1A1A1A] text-white/90 py-4 px-8 font-semibold">
      <span>{text1}</span>
      <span>{text2}</span>
    </button>
  )
}

function LanguageTab() {
  const setTab = useSetAtom(activeTabAtom);
  const {setAccountLang} = useApi();
  const setLang = useSetAtom(selectedLangAtom);

  const initLang = (langTag) => {
    setAccountLang(langTag).then(_ => {
      setLang(langTag);
      setTab("demo1");
    });
  }

  return (
    <div className="w-full h-full bg-black flex flex-col">
    <div className="flex flex-col h-[40%] justify-end items-left gap-12 px-12">
      <h1 className="font-black text-white/90 text-3xl">Select your <br />Language</h1>
    </div>
    <div className='flex w-full flex-col p-12 mb-12 justify-start flex-grow items-stretch gap-4'>
      <RegularButton onClick={_ => initLang("EN")} text1="English" text2="🇬🇧" />
      <RegularButton onClick={_ => initLang("RU")} text1="Русский" text2="🇷🇺" />
    </div>
  </div>
  )
}


function SwitchTab() {
  const activeTab = useAtomValue(activeTabAtom);
  const { i18n: i18next } = useTranslation();
  const selectedLang = useAtomValue(selectedLangAtom);

  useEffect(_ => {
    queryClient.cancelQueries({ queryKey: ['videos'] })
    queryClient.setQueryData(['videos'], _ => {
      return {
        pages: [],
        pageParams: [],
      }
    })
  }, [activeTab]);

  useEffect(() => {
    if (i18next) {
      i18next.changeLanguage(selectedLang.toLowerCase(), (err, t) => {
        if (err) return console.log('something went wrong loading', err);
      });
    }
  }, [i18next, selectedLang]);

  if (activeTab === 'home' || activeTab === 'demo1') {
    return <ScrollVisibility showOverlayInitial={activeTab === 'demo1'} />
  } else if (activeTab === 'language') {
    return <LanguageTab />
  }
}

// function TelegramPostInit({ children }) {
//   const startParam = useStartParam();
//   const platform = usePlatform();
//   const {requestAccountInit} = useApi();
//   const [ready, setReady] = useState(false);
//   const [_, setAccRef] = useAtom(personalRefCodeAtom);
//   const setLang = useSetAtom(selectedLangAtom);
//   const setTab = useSetAtom(activeTabAtom);

//   useEffect(_ => {
//     if (platform && platform !== 'tdesktop' && platform !== 'macos' && platform !== 'weba' && platform !== 'webb') {
//       postEvent('web_app_request_fullscreen');
//     }
//     postEvent('web_app_setup_swipe_behavior', { allow_vertical_swipe: false });
//     postEvent('web_app_set_background_color', { color: '#000000' });
//     postEvent('web_app_set_bottom_bar_color', { color: '#000000' });
//     postEvent('web_app_set_header_color', { color: '#000000' });
//   }, [platform]);
//   useEffect(_ => {
//     if (!ready) {
//       let params = {};
//       if (startParam && startParam.referal) {
//         params.ref = startParam.referal;
//       }
//       requestAccountInit(params).then(acc => {
//         if (acc && acc.ref) {
//           setAccRef(acc.ref);
//         }
//         if (acc) {
//           if (acc.Language === "") {
//             setTab("language");
//           } else {
//             setLang(acc.Language);
//           }
//         }
//         setReady(true);
//       }, err => {
//         console.error(err);
//       })
//     }
//   }, [startParam, ready]);
//   useEffect(_ => {
//     if (
//       miniApp.setHeaderColor.isAvailable()
//       && miniApp.setHeaderColor.supports('rgb')
//     ) {
//       miniApp.setHeaderColor('#000000');
//     }
//     if (miniApp.setBackgroundColor.isAvailable()) {
//       miniApp.setBackgroundColor('#000000');
//     }
//   }, [miniApp]);
//   if (!ready) return <AppGlobalLoader />;
//   return <>{children}</>
// }

// function TelegramInit({ children }) {
//   const [ready, setReady] = useState(false);
//   const telegramLaunch = _ => {
//     mockTelegramEnv(initDataDefault);
//     init();
//     (async () => {try {
//       await telegramAnalytics.init({
//         token: 'eyJhcHBfbmFtZSI6InN3aXBlYXBwIiwiYXBwX3VybCI6Imh0dHBzOi8vdC5tZS9hcHBzd2lwZV9ib3QiLCJhcHBfZG9tYWluIjoiaHR0cHM6Ly9zd2lwZWFwcC5jYy8ifQ==!Tpk87A1BObuY+0uOnliPQJ84A+iKWcdWo6QdZyiqU5s=',
//         appName: 'swipeapp',
//       })
//     } catch(e) {} finally {}})().then(_ => {});
//   };
//   useEffect(_ => {
//       telegramLaunch();
//       setReady(true);
//   }, []);
//   if (!ready) return <AppGlobalLoader />;
//   return <>{children}</>
// }

function App() {
  return (
    <div className="flex flex-row w-full h-full justify-center items-center">
      {/* <TelegramInit>
        <TelegramPostInit> */}
          <div className="relative flex flex-col bg-black h-[100vh] w-full flex-shrink-0 max-w-[70vh]">
            <SwitchTab />
            <BottomBar />
          </div>
        {/* </TelegramPostInit>
      </TelegramInit> */}
    </div>
  );
}

export default App;
